import axios from 'axios';
import Rollbar from 'rollbar';

import { rollbarConfig } from '../../rollbar-config';

export enum CmsArticles {
  HOME_PAGE = '1627839793264',
  APPLICATION_SIGNATURES = '1634229618450',
  ESSAY_LEGAL_TEXT = '1633365412130',
  NON_PURCHASER_CERTIFICATION = '1660576109365',
  PURCHASER_CERTIFICATION = '1660576035607',
  PURCHASER_LEGAL_TEXT = '1636126195311'
}

export const fetchCmsArticle = (articleId: string): Promise<string> => {
  return new Promise(async (resolve, reject) => {
    const queryParams = new URLSearchParams(window.location.search);
    const rollbar = new Rollbar(rollbarConfig);
    if (queryParams.get('swap') === articleId) {
      articleId = `preview_${queryParams.get('with')}` || articleId;
    }
    try {
      const response = await axios.get(`${process.env.REACT_APP_CMS_URL}/v1/article/mtpf/${articleId}`);

      resolve(response.data.data.contents);
    } catch (error) {
      const errorForLog = error instanceof Error ? error : new Error(String(error));
      rollbar.error(`Error loading CMS Article ${articleId}`, errorForLog, { articleId });
      reject(errorForLog);
    }
  });
};
